module.exports = __webpack_public_path__ + "04_glasses_brown.c41d5b7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer4/04_glasses_brown.png
// module id = Ukjt
// module chunks = 0